import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import CryptoJS from 'crypto-js'

Vue.config.lKey = '52b1fcc2-b0ec-467a-8434-89ac4550fa42'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isLogged: false,
    isInternalStaff: false,
    isRustyAccount: false,
    kioskMode: false,
    currentRole: 'User',
    subscriptions: '',
    passwordChangeRequired: false,
    AcademyShow: false,
    AcademyToken: undefined,
    AcademyURL: undefined
  },
  mutations: {
    SET_ACADEMY (state, data) {
      state.AcademyShow = data.show
      state.AcademyToken = data.token
      state.AcademyURL = data.url
    },

    LOGIN_USER (state) {
      state.isLogged = true
    },

    LOGOUT_USER (state) {
      state.isLogged = false
      state.passwordChangeRequired = false
    },

    ROLE_SETUP (state, x) {
      state.currentRole = x
    },

    SUBSCRIPTIONS_SETUP (state, x) {
      state.subscriptions = x
    },

    PASSWORD_CHANGE_REQUIRED (state, x) {
      state.passwordChangeRequired = x
    },

    IS_INTERNAL_STAFF (state, x) {
      state.isInternalStaff = x
    },

    IS_RUSTY_ACCOUNT (state, x) {
      state.isRustyAccount = x
    },

    KIOSK_MODE (state, x) {
      state.kioskMode = x
    }
  },
  getters: {
    GetAcademyToken: state => {
      return state.AcademyToken
    },
    GetAcademyShow: state => {
      return state.AcademyShow
    },
    GetAcademyURL: state => {
      return state.AcademyURL
    },
    IsInternalStaff: state => {
      return state.isInternalStaff
    }
  },
  plugins: [createPersistedState({
    key: 'rKey',
    storage: {
      getItem: (key) => {
        try {
          let ciphertext = (window && window.localStorage).getItem(key)
          let bytes = CryptoJS.AES.decrypt(ciphertext.toString(), Vue.config.lKey)
          let plaintext = bytes.toString(CryptoJS.enc.Utf8)

          if (plaintext !== undefined) {
            return JSON.parse(plaintext)
          }
        } catch (err) {
        }
        return undefined
      },
      setItem: (key, value) => {
        try {
          let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), Vue.config.lKey);
          (window && window.localStorage).setItem(key, ciphertext)
        } catch (err) {
        }
      },
      removeItem: (key) => {
        try {
          (window && window.localStorage).setItem(key, undefined)
        } catch (err) {
        }
        return undefined
      }
    }
  })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js